import { Button, View, Text } from "@aws-amplify/ui-react";

export default function HealthSummarySectionCard({
  label,
  updatedAt,
  onViewClick,
}) {
  return (
    <View backgroundColor={"white"}>
      <Button onClick={onViewClick} variation="link">
        {label}
      </Button>
      {
        <View marginLeft={15}>
          <Text
            fontSize="12px"
            fontWeight="400"
            color="rgba(48,64,80,1)"
            lineHeight="24px"
          >{`Last update: ${updatedAt}`}</Text>
        </View>
      }
    </View>
  );
}
